import { useCallback, useEffect, useState } from 'react';

import useManualRequest from '@web-shared/hooks/useManualRequest';
import { createAuditLog } from '../../../api';
import { getCurrentLocation } from '../../../services/geolocation';

export const useGeolocation = (token: string) => {
  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const geolocationRequest = useManualRequest(createAuditLog);
  const fetchPosition = useCallback(async () => {
    setLoading(true);
    try {
      const position = await getCurrentLocation();
      setError(false);

      setPosition(position);
      geolocationRequest.trigger({ token, position });
    } catch {
      setError(true);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    fetchPosition();
  }, [token]);

  return { position, error, loading, refetch: fetchPosition };
};

